"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Copyright 2013-present, Novivia, Inc.
                    * All rights reserved.
                    */

var _SocialLoginButton = require("./SocialLoginButton");

var _SocialLoginButton2 = _interopRequireDefault(_SocialLoginButton);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Social logins.
 * @class
 */
var SocialLogins = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SocialLogins, _Component);

  function SocialLogins() {
    (0, _classCallCheck3.default)(this, SocialLogins);
    return (0, _possibleConstructorReturn3.default)(this, (SocialLogins.__proto__ || (0, _getPrototypeOf2.default)(SocialLogins)).apply(this, arguments));
  }

  (0, _createClass3.default)(SocialLogins, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        "div",
        null,
        this.props.socialLogin.map(function (social, index) {
          return _react2.default.createElement(_SocialLoginButton2.default, {
            key: index,
            socialLogin: social,
            urlToken: _this2.props.urlToken
          });
        })
      );
    }
  }]);
  return SocialLogins;
}(_react.Component), _class.propTypes = {
  // Organizations of the social login buttons.
  socialLogin: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(["google", "facebook", "linkedin"])).isRequired,

  // Token in url query string.
  urlToken: _propTypes2.default.string
}, _class.defaultProps = {
  socialLogin: ["google", "facebook", "linkedin"]
}, _temp);
exports.default = SocialLogins;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/SocialLogins.jsx
// module id = 212
// module chunks = 9 10 11 15 18 19 23 65 66 68